import PropTypes from 'prop-types'
import { useContext } from 'react'

// Internal components
import Button from '../Button/Button'

// Context
import { AppContext } from '../../context/AppContext'

const ShareOptions = (props) => {
  const { items, modifiers } = props
  const appContext = useContext(AppContext)
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  const openShareLink = (href) => {
    const url = encodeURI(window.location.href)
    const title = encodeURI(document.title)
    const link = href.replace('{url}', url).replace('{title}', title)
    window.open(link, '_blank')
  }

  const openShareNative = () => {
    const currentUrl = encodeURI(window.location.href)
    window.location.href = 'share://' + currentUrl
  }

  return (
    <div className={`ShareOptions${modifierClasses}`}>
      <ul className="ShareOptions-list">
        {appContext?.isNativeApp ? (
          <li className={'ShareOptions-item'}>
            <Button
              icon={{ id: 'icon-share' }}
              modifiers={['Button--shareOptions', 'Button--shareOptionsNative']}
              onClick={openShareNative}
            />
          </li>
        ) : (
          <>
            {items &&
              items.map((item, index) => {
                return (
                  <li className={'ShareOptions-item'} key={`ShareOptions-item--${index}`}>
                    <Button
                      icon={{ id: item.icon }}
                      modifiers={['Button--shareOptions', `Button--shareOptions${item.label.toLowerCase()}`]}
                      modal={item?.modal}
                      onClick={() => openShareLink(item.href)}
                    />
                  </li>
                )
              })}
            <li className={'ShareOptions-item'}>
              <Button
                icon={{ id: 'icon-email' }}
                modifiers={['Button--shareOptions', 'Button--shareOptionsEmail']}
                modal={{ type: 'api', route: 'get/shareoptions/email/open', modifier: 'Modal--email' }}
              />
            </li>
            <li className={'ShareOptions-item'}>
              <Button
                icon={{ id: 'icon-copylink' }}
                modifiers={['Button--shareOptions', 'Button--shareOptionsCopy']}
                modal={{ type: 'api', route: 'get/shareoptions/copylink', modifier: 'Modal--copylink' }}
              />
            </li>
          </>
        )}
      </ul>
    </div>
  )
}

ShareOptions.propTypes = {
  items: PropTypes.array,
  modifiers: PropTypes.array
}

export default ShareOptions
